<p-accordion
  [value]="value()"
  (valueChange)="handleValueChange($event)"
  [multiple]="multiple()"
  [styleClass]="styleClass()"
  [expandIcon]="expandIcon()"
  [collapseIcon]="collapseIcon()">

  <p-accordion-panel
    *ngFor="let panel of panels(); let i = index; trackBy: trackByHeader"
    [value]="headerLabel(panel)"
    [disabled]="panel.disabled ?? false">

    <p-accordion-header>
      <ng-container
        *ngIf="headerTemplate(); else defaultHeader"
        [ngTemplateOutlet]="headerTemplate()!"
        [ngTemplateOutletContext]="{ $implicit: panel, index: i }">
      </ng-container>
      <ng-template #defaultHeader>
        <i *ngIf="panel.icon" [class]="panel.icon + ' mr-2'"></i>
        {{ headerLabel(panel) }}
      </ng-template>
    </p-accordion-header>

    <p-accordion-content>
      <ng-container
        *ngIf="contentTemplate(); else defaultContent"
        [ngTemplateOutlet]="contentTemplate()!"
        [ngTemplateOutletContext]="{ $implicit: panel, index: i }">
      </ng-container>
      <ng-template #defaultContent>
        {{ panel.content }}
      </ng-template>
    </p-accordion-content>

  </p-accordion-panel>

</p-accordion>
